import { useEffect, useState } from 'react';
import { useAppSettings, useSpringBigStore } from '@springbig/shared';
import { Plan } from '@springbig/shared';
import { isAfter, addHours } from 'date-fns';

const useSubscriptionPlansHelpers = () => {

    const [plans, setPlans] = useState<Plan[]>(null);
    const [subscribedPlans, setSubscribedPlans] = useState<Plan[]>(null);
    const [hasWarning, setHasWarning] = useState<boolean>(false);
    const [showSubPrompt, setShowSubPrompt] = useState<boolean>(false);
    const [showSuspendedMethodWarning, setShowSuspendedMethodWarning] = useState<boolean>(false);
    const [suspendedPaymentMethods, setSuspendedPaymentMethods] = useState<string[]>([]);
    const { member } = useSpringBigStore();
    const { showSubscriptionPrompt } = useAppSettings();

    useEffect(() => {

        if (member) {
            setPlans(
                // active plans member is not subscribed to
                member.subscription_plans.filter(
                    plan => plan.status === 'active' && !plan.subscription
                )
            );
            setSubscribedPlans(
                // active plans member is subscribed to
                member.subscription_plans.filter(
                    plan => plan.status === 'active' && plan.subscription
                )
            );
            setHasWarning(
                // any subscription has a failed payment
                member.subscription_plans.some(
                    plan => plan.status === 'active' && plan.subscription?.status === 'suspended'
                )
            );
            // there are active plans, none of which member is subscribed to
            // prompt was never shown or more than 2 hours ago
            // member did not dismiss the popup
            const hasActivePlans = member.subscription_plans.some(
                plan => plan.status === 'active'
            );
            const membersIsSubsribedToActivePlan  = member.subscription_plans.some(
                plan => plan.status === 'active' && plan.subscription
            );
            setShowSubPrompt(
                showSubscriptionPrompt !== false && hasActivePlans && !membersIsSubsribedToActivePlan &&
                member.show_sub_prompt &&
                (
                    !localStorage.getItem('last_shown_subs_prompt')
                    ||
                    isAfter(
                        new Date(),
                        addHours(new Date(
                            JSON.parse(
                                localStorage.getItem('last_shown_subs_prompt')
                            )
                        ), 2)
                    )
                )
            );
            
            const subscriptionPlan = member.subscription_plans;
            const paymentMethods : string[] = [];
            subscriptionPlan?.forEach((plan) => {
                    if (plan?.status === 'active') {
                        if (plan?.subscription?.status === 'suspended') {
                            if (plan?.subscription?.cc_last_four) {
                                paymentMethods?.push(plan?.subscription?.cc_last_four);
                            }
                        }
                    }
                }
            );
            setSuspendedPaymentMethods(paymentMethods);
        }
    }, [member]);

    return {
        plans,
        subscribedPlans,
        hasWarning,
        suspendedPaymentMethods,
        setSuspendedPaymentMethods,
        setShowSuspendedMethodWarning,
        showSuspendedMethodWarning
    };
};

export default useSubscriptionPlansHelpers;
